import { PhoneCall } from "lucide-react";

import { formatPhoneNumber } from "@/lib/utils";

export default function PhoneCallButton({
  conversion,
  primaryClass,
}: {
  conversion: { value: string };
  primaryClass: string;
}) {
  return (
    <a href={`tel:${conversion.value}`} type="tel" className={primaryClass}>
      <PhoneCall className="relative inline-block h-4 w-4 mr-2" /> {formatPhoneNumber(conversion.value)}
    </a>
  );
}
